import React from 'react';
import { IoCloseSharp } from "react-icons/io5";
import Slider from 'react-slick';

const images = [
    'https://res.cloudinary.com/dahgxnpog/image/upload/v1735589031/home_blog_svqy9x.png',
    'https://res.cloudinary.com/dahgxnpog/image/upload/v1735589038/home_blog_light_sw3czn.png',
    'https://res.cloudinary.com/dahgxnpog/image/upload/v1735589022/dashboard_dark_txmcj1.png',
    'https://res.cloudinary.com/dahgxnpog/image/upload/v1735589022/dashboard_light_hq61jx.png',
    'https://res.cloudinary.com/dahgxnpog/image/upload/v1735589021/create_dark_wjtqfl.png',
    'https://res.cloudinary.com/dahgxnpog/image/upload/v1735589021/create_light_ckd0rr.png'
];

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: true,
    adaptiveHeight: true
};

const DocumentationDetail = ({ viewDetail }) => {
    return (
        <div className='viewDetail'>
            <div className='detailHeader'>
                <IoCloseSharp className='closeDetail' onClick={()=>viewDetail(null)}/>
            </div>
            <div className='projectDetailContainer'>
            <h1 className='projectName'>Blogger : A Fullstack Multi-User Blog Platform</h1>
            </div>
            <div className='projectDetailContainer'>

                <div className='lists'>
                    <h2 className='listGeneralName'>Project Overview</h2>
                    <p>
                        <b>Purpose:</b> The project was developed as a user-friendly platform where multiple users can create, publish, and interact with blogs.
                    </p>
                    <p>
                        <b>Primary Features:</b> The platform now includes fully functional blog browsing, creation, user interaction, and admin moderation tools.
                    </p>
                    <p>
                        <b>Tech Stack:</b> Next.js, TypeScript, TailwindCSS, MongoDB (Atlas), Prisma, Vercel, and GitHub Actions for CI/CD.
                    </p>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Agile Workflow</h2>
                    <div className='list'>
                        <p><b>Framework:</b> Scrum</p>
                        <p><b>Sprint Duration:</b> 2 weeks</p>
                        <p><b>Deliverables:</b> Working, tested, and deployed increments.</p>
                    </div>
                    <div className='list'>
                        <p><b>Artifacts:</b></p>
                        <ul>
                            <li>Product Backlog in JIRA.</li>
                            <li>Sprint Backlog with refined items.</li>
                            <li>Definition of Done (DoD): Reviewed, tested, and deployed.</li>
                        </ul>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Screenshots</h2>
                    <div className='screenshotsContainer'>
                        <Slider {...settings}>
                            {images.map((image, index) => (
                                <div key={index} className='slide'>
                                    <img src={image} alt={`Screenshot ${index + 1}`} />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>User Journeys</h2>
                    <div className='list'>
                        <h3>Visitor Journey</h3>
                        <p>Discover and read blogs seamlessly.</p>
                    </div>
                    <div className='list'>
                        <h3>Registered User Journey</h3>
                        <p>Engage with content and personalize the experience.</p>
                    </div>
                    <div className='list'>
                        <h3>Author Journey</h3>
                        <p>Create and manage blog content.</p>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Architecture Overview</h2>
                    <div className='list'>
                        <p><b>Frontend:</b> Next.js with TailwindCSS</p>
                        <p><b>Backend:</b> API routes with Prisma ORM</p>
                        <p><b>Database:</b> MongoDB Atlas</p>
                        <p><b>CI/CD:</b> GitHub Actions</p>
                        <p><b>Hosting:</b> Vercel</p>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Testing Strategy</h2>
                    <div className='list'>
                        <p><b>Unit Testing:</b> Jest</p>
                        <p><b>Integration Testing:</b> Prisma API endpoints</p>
                        <p><b>End-to-End Testing:</b> Cypress</p>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Deployment Process</h2>
                    <p>
                        Automated CI/CD pipelines run tests, deploy to staging, and release to production after approval. The application is hosted on Vercel with MongoDB Atlas as the database.
                    </p>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Future Enhancements</h2>
                    <ul>
                        <li>Visitor features: Save blogs to reading lists.</li>
                        <li>Author features: Schedule blog posts.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default DocumentationDetail;
